var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 23.25H19.1425C20.5237 23.25 21.6425 22.1312 21.6425 20.75V2C21.6425 1.31 21.0825 0.75 20.3925 0.75H18.0712C17.3812 0.75 16.8212 1.31 16.8212 2V4.8825",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.3923L10.3725 2.14484C11.3088 1.34234 12.69 1.34234 13.6263 2.14484L23.25 10.3923",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "planIcon",
    d: "M8.94469 17.2793L6.51344 19.7105L5.05469 18.2518",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "planIcon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09406 19.2666L1.92406 20.3528L2.10406 21.7041C2.20406 22.4541 2.79281 23.0441 3.54281 23.1441L4.89781 23.3253L5.98281 24.1553C6.58281 24.6141 7.41656 24.6141 8.01656 24.1553L9.10281 23.3253H9.10156L10.4541 23.1453C11.2041 23.0453 11.7941 22.4566 11.8941 21.7066L12.0753 20.3516C12.0753 20.3528 12.4953 19.8028 12.9053 19.2666C13.3641 18.6666 13.3641 17.8328 12.9053 17.2328L12.0753 16.1466L11.8953 14.7953C11.7953 14.0453 11.2066 13.4553 10.4566 13.3553L9.10156 13.1741L8.01656 12.3441C7.41656 11.8853 6.58281 11.8853 5.98281 12.3441L4.89656 13.1741H4.89781L3.54531 13.3541C2.79531 13.4541 2.20531 14.0428 2.10531 14.7928L1.92406 16.1478C1.92406 16.1466 1.50406 16.6966 1.09406 17.2328C0.635312 17.8328 0.635312 18.6653 1.09406 19.2666Z",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaint);
export default __webpack_public_path__ + "static/media/complaint.0c98cd91.svg";
export { ForwardRef as ReactComponent };